export default function PlusIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={14}
        height={14}
        viewBox="0 0 9 10"
        fill="none"
      >
        <path
          d="M4.66016 1.32031V9"
          stroke="#0047ab"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.820312 5.16016H8.5"
          stroke="#0047ab"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
